import React from 'react';
import { SeedIcon, SparkleIcon } from './icons';

export const BelongingFooter = () => {
  return (
    <footer className="py-8 border-t border-[var(--muted)]/50 bg-[var(--panel)]/50">
      <div className="container mx-auto px-4">
        {/* Main footer content */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-6">
          {/* Logo and tagline */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[var(--primary)] flex items-center justify-center">
              <SeedIcon size={20} className="text-white" />
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-[var(--fg)]">Bliss Abode</h4>
              <p className="text-xs text-[var(--fg)]/60">Part of the Belonging Sessions Family</p>
            </div>
          </div>

          {/* Family of sites */}
          <div className="flex flex-wrap items-center justify-center gap-4 text-xs">
            <a 
              href="https://blissabode.org" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[var(--fg)]/70 hover:text-[var(--primary)] transition-colors font-medium"
            >
              Bliss Abode
            </a>
            <span className="text-[var(--fg)]/30">•</span>
            <a 
              href="https://belongingsessions.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[var(--fg)]/70 hover:text-[var(--primary)] transition-colors"
            >
              Belonging Sessions
            </a>
            <span className="text-[var(--fg)]/30">•</span>
            <a 
              href="https://mairy.io" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[var(--fg)]/70 hover:text-[var(--primary)] transition-colors flex items-center gap-1"
            >
              <SparkleIcon size={12} />
              M.ai.ry
            </a>
            <span className="text-[var(--fg)]/30">•</span>
            <a 
              href="https://elchme.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[var(--fg)]/70 hover:text-[var(--primary)] transition-colors"
            >
              ElchmE
            </a>
            <span className="text-[var(--fg)]/30">•</span>
            <a 
              href="https://planetaryfam.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[var(--fg)]/70 hover:text-[var(--primary)] transition-colors"
            >
              PlanetaryFam
            </a>
          </div>
        </div>

        {/* The Four Pillars */}
        <div className="flex flex-col items-center gap-3 mb-6">
          <p className="text-xs text-[var(--fg)]/50">The Four Pillars</p>
          <div className="flex gap-3">
            {['Belonging', 'Agency', 'Security', 'Trust'].map((pillar, i) => (
              <span 
                key={pillar}
                className="text-xs px-3 py-1 rounded-full bg-[var(--sky)] text-[var(--fg)]/70 font-medium"
              >
                {pillar}
              </span>
            ))}
          </div>
        </div>

        {/* Tagline */}
        <div className="text-center">
          <p className="text-xs text-[var(--fg)]/40 italic">
            "planetary confluence through shared remembrance"
          </p>
          <p className="text-[10px] text-[var(--fg)]/30 mt-2">
            the world's first family-aligned community architecture
          </p>
        </div>

        {/* Copyright */}
        <div className="text-center mt-6 pt-4 border-t border-[var(--muted)]/30">
          <p className="text-[10px] text-[var(--fg)]/30">
            © {new Date().getFullYear()} Bliss Abode • Belonging Sessions Family • Trust as Currency
          </p>
        </div>
      </div>
    </footer>
  );
};
